exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name[data-v-5838cd1c]{font-size:14px}.xm-container[data-v-5838cd1c]{position:relative;width:100%;padding-left:200px}.xm-content[data-v-5838cd1c]{position:relative;width:920px;margin:62px auto 55px;border-radius:6px;background:#fff}.appointment-container[data-v-5838cd1c],.export-container[data-v-5838cd1c]{width:1034px;min-height:583px;background:#fff;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports
